'use client'
import React from 'react';
import Image from 'next/image';
import RoomPlanOnBoarding from '../RoomPlanOnBoarding';
import Button, { ButtonType } from '../Button';
interface HeroSectionProps {
    heroImage: any;
    modalOpen: boolean;
    setModalOpen: (open: boolean) => void;
    handleClickCreateDesign: () => void;
    buttonText: string;
    underButtonText: string;
}
const HeroSection: React.FC<HeroSectionProps> = (props) => {
    const { heroImage, modalOpen, setModalOpen, handleClickCreateDesign, buttonText, underButtonText } = props;

    return (
        <div className="relative w-full h-screen overflow-hidden">
            {/* Background Image */}
            <Image
                src={heroImage}
                alt="Hero Background"
                fill={true}
                priority={true}
                placeholder="blur"
                className="object-cover"
            />

            {/* Content */}
            <div className="relative z-10 flex flex-col items-center justify-center h-full text-white text-center px-4">
                <div className="w-80 h-80 rounded-full flex flex-col items-center justify-center space-y-4 shadow-lg bg-opacity-90" style={{
                    background: "linear-gradient(to bottom, rgba(222, 148, 68, 0.6) 27%, rgba(120, 80, 37, 0.6) 100%)"
                    ,
                }}>
                    <h1 className="text-3xl md:text-4xl font-bold">Welcome!</h1>
                    <Button text={buttonText} onClick={handleClickCreateDesign} className='px-8' buttonType={ButtonType.SECONDARY} />
                    <h3>{underButtonText}</h3>
                </div>
            </div>

            {/* Room plan Onboarding */}
            <RoomPlanOnBoarding modalOpen={modalOpen} setModalOpen={setModalOpen} />
        </div>
    );
};

export default HeroSection;
